import useDebouncedCallback from "app/core/hooks/useDebounceCallback"
import { debug as debugMain } from "debug"
import { useCallback } from "react"
import { MessageDirection, wrap } from "@superwall-me/schema"

const debug = debugMain("paywallBuilder:useBuilderPostMessage")

const useBuilderPostMessage = (iframeRef) => {
  const sendTemplateData = useCallback(
    (json, reset?: boolean) => {
      const wrappedMessage = wrap(
        { event_name: "template_json", json, reset: !!reset },
        MessageDirection.ToPaywallUi
      )
      if (iframeRef?.current?.contentWindow) {
        try {
          iframeRef.current.contentWindow.postMessage(wrappedMessage, "*")
        } catch (e) {
          debug("failed to post message", e)
        }
      }
    },
    [iframeRef]
  )

  return { sendTemplateData }
}

export default useBuilderPostMessage
